import messages from './AdacConfigurableForm.messages';

export const getLabelForElement = (element) => {
    const labelElement = element.closest('form')?.querySelector(`label[for="${element.id}"]`);

    if (labelElement) {
        return labelElement.textContent.trim();
    }
    return '';
};

export const parseJSONStringToObject = (validateDateStr) => {
    try {
        return JSON.parse(validateDateStr);
    } catch (e) {
        console.error('Failed to parse validateDate:', e);
        return {};
    }
};

export const validateDateField = (date, rules, required, translator) => {
    if (!date && required) {
        return translator(messages.requiredFieldValidationMessage);
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);

    if (rules.minDate) {
        const minDate = new Date(rules.minDate);
        if (dateObj < minDate) {
            return translator(messages.dateCannotBeBeforeValidationMessage, {
                minDate: minDate.toLocaleDateString('de-DE'),
            });
        }
    }

    if (rules.maxDate) {
        const maxDate = new Date(rules.maxDate);
        if (dateObj > maxDate) {
            return translator(messages.dateCannotBeAfterValidationMessage, {
                maxDate: maxDate.toLocaleDateString('de-DE'),
            });
        }
    }

    if (rules.future === false && dateObj > today) {
        return translator(messages.dateCannotBeFutureDateValidationMessage);
    }

    if (rules.past === false && dateObj < today) {
        return translator(messages.dateCannotBePastDateValidationMessage);
    }

    if (!rules.future && !rules.past && dateObj.getTime() !== today.getTime()) {
        return translator(messages.onlyTodayIsAvailableDateValidationMessage);
    }

    return null;
};

export const validateTextField = (value, rules, required, translator) => {
    if (!value && required) {
        return translator(messages.requiredFieldValidationMessage);
    }

    if (rules.regex) {
        const validationRegex = new RegExp(rules.regex);
        if (!validationRegex.test(value)) {
            return rules.validationMessage;
        }
    }

    return null;
};
